import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Sticky from 'react-stickynode';
import { connect } from 'react-redux';
import { resetFacetValues, search, selectCollection, toggleFacetValue, updateSort } from '../../actions/RegistryCollectionActions';

class Bucket extends Component {

  constructor(props) {
    super(props);

    this.toggleFacet = this.toggleFacet.bind(this);

    this.state = {
      checked: false
    };
  }

  componentWillMount() {
    const { facet, facetValue, selectedFacetValues } = this.props;
    const checked = selectedFacetValues && selectedFacetValues[facet.key] !== undefined && _.indexOf(selectedFacetValues[facet.key], facetValue.value) > -1;
    this.setState({ checked });
  }

  componentWillReceiveProps(nextProps) {
    const { facet, facetValue, selectedFacetValues } = nextProps;
    const checked = selectedFacetValues && selectedFacetValues[facet.key] !== undefined && _.indexOf(selectedFacetValues[facet.key], facetValue.value) > -1;
    this.setState({ checked });
  }

  toggleFacet(e) {
    const { facet, facetValue, onToggleFacet, enableCustomCollections } = this.props;
    this.setState({ checked: e.target.checked });
    onToggleFacet(facet.key, facetValue.value, false, enableCustomCollections);
  }

  render() {
    const { facet, facetValue } = this.props;

    return (
      <li key={facetValue.value} className={`checkbox${this.state.checked ? ' active' : ''}`}>
        <label htmlFor={`${facet.key}-${facetValue.value}`}>
          <input id={`${facet.key}-${facetValue.value}`} type="checkbox" value={facetValue.value} onChange={this.toggleFacet} checked={this.state.checked} style={{ display: 'inline-block' }} />
          {facetValue.label} <small className="text-muted">({facetValue.result_count})</small>
        </label>
      </li>
    );
  }
}

Bucket.propTypes = {
  facet: PropTypes.shape({}),
  facetValue: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  enableCustomCollections: PropTypes.bool,
};

const Facet = ({ facet, selectedFacetValues, onToggleFacet, onResetFacets, enableCustomCollections }) => {
  if (!facet.options || facet.options.length === 0) return null;

  const hasFacetValuesSelected = selectedFacetValues && !!_.size(selectedFacetValues[facet.key]);

  return (
    <div key={facet.key} className="rail-control filter-control">

      <h6 className="rail-header">
        {facet.label}
        {hasFacetValuesSelected && (
          <a role="button" className="clear-filter" onClick={() => onResetFacets(facet.key, enableCustomCollections)}>Clear</a>
        )}
      </h6>
      <ul className="facet-options list-unstyled">
        {facet.options.map(facetValue => (
          <Bucket key={facetValue.value} facet={facet} facetValue={facetValue} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} enableCustomCollections={enableCustomCollections} />
        ))}
      </ul>
    </div>
  );
};


Facet.propTypes = {
  facet: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  enableCustomCollections: PropTypes.bool,
};

class FacetList extends Component {
  constructor(props) {
    super(props);

    this.toggleFilters = this.toggleFilters.bind(this);

    this.state = {
      filtersExpanded: false
    };
  }

  toggleFilters() {
    this.setState({
      filtersExpanded: !this.state.filtersExpanded
    });
  }

  render() {
    const { collectionList, facets, selectedFacetValues, selectedCollectionObjectId, onToggleFacet, onResetFacets, onSelectCollection, sort, onUpdateSort, forPreview, enableCustomCollections } = this.props;
    const { filtersExpanded } = this.state;
    const hasFacetsSelected = _.size(selectedFacetValues) > 0;
    const hasSort = sort !== '';
    const stickyProps = forPreview ? { enabled: false } : {};
    const groupByFacetLabel = enableCustomCollections ? 'Collections' : 'Categories';

    return (
      <div className="facets">
        <div className="mobile-controls-toggle hidden-md hidden-lg">
          <button className="btn btn-xs btn-secondary" onClick={this.toggleFilters}>
            Filter/Sort <span className={`glyphicon ${filtersExpanded ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-top'}`} />
          </button>
        </div>
        <Sticky top={190} bottomBoundary={'#public-registry'} enableTransforms={false} className="hidden-sm hidden-xs" {...stickyProps}>
          {collectionList.length > 0 && (
            <div className="rail-control" style={{ marginTop: '15px' }}>
              <h6 className="rail-header">{groupByFacetLabel}</h6>
              <div className="rail-tree">
                <a role="button" className={`tree-root expanded${selectedCollectionObjectId ? '' : ' active'}`} onClick={() => onSelectCollection(undefined, enableCustomCollections)}>All {groupByFacetLabel}</a>
                <ul className="nav nav-rail">
                  {collectionList.map(collection => (
                    <li key={collection.object_id} className={selectedCollectionObjectId === collection.object_id ? 'active' : ''}>
                      <a role="button" onClick={() => onSelectCollection(collection.object_id, enableCustomCollections)}>{collection.title}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {facets.map(facet => (
            <Facet key={facet.key} facet={facet} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={onResetFacets} enableCustomCollections={enableCustomCollections} />
          ))}
          {(hasFacetsSelected || selectedCollectionObjectId || hasSort) && <a role="button" className="btn btn-secondary hidden-sm hidden-xs" onClick={() => onResetFacets(undefined, enableCustomCollections)}>Clear All Filters</a>}
        </Sticky>

        {/* Mobile Filters */}
        {filtersExpanded && (
          <div className="form-horizontal form-horizontal-xs hidden-md hidden-lg">
            <div className="form-group form-group-sm">
              <label htmlFor="public-registry-collection-sort-mobile" className="col-xs-3 control-label">{groupByFacetLabel}:</label>
              <div className="col-xs-9 col-sm-6">
                <select id="public-registry-collection-sort-mobile" className="form-control" value={selectedCollectionObjectId || ''} onChange={e => onSelectCollection(e.target.value, enableCustomCollections)}>
                  <option value="">All</option>
                  {collectionList.map(collection => (
                    <option key={collection.object_id} value={collection.object_id}>{collection.title}</option>
                  ))}
                </select>
              </div>
            </div>
            {facets.map(facet => (
              <div key={facet.key} className="form-group form-group-sm">
                <label htmlFor={`${facet.key}-facet-mobile`} className="col-xs-3 control-label">{facet.label}:</label>
                <div className="col-xs-9 col-sm-6">
                  <select id={`${facet.key}-facet-mobile`} className="form-control" value={(selectedFacetValues && selectedFacetValues[facet.key]) || ''} onChange={e => onToggleFacet(facet.key, e.target.value, true, enableCustomCollections)}>
                    <option value="">All</option>
                    {facet.options.map(facetValue => (
                      <option
                        key={facetValue.value}
                        value={facetValue.value}
                        disabled={facetValue.result_count === 0}
                      >{facetValue.label} ({facetValue.result_count})</option>
                    ))}
                  </select>
                </div>
              </div>
            ))}
            <div className="form-group form-group-sm">
              <label htmlFor="public-registry-sort-mobile" className="col-xs-3 control-label">Sort by:</label>
              <div className="col-xs-9 col-sm-6">
                <select id="public-registry-sort-mobile" name="public-registry-sort" className="form-control" onChange={onUpdateSort} value={sort}>
                  <option value="">Featured</option>
                  <option value="PRICE_ASC" label="Price: Low to High">Price: Low to High</option>
                  <option value="PRICE_DESC" label="Price: High to Low">Price: High to Low</option>
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

FacetList.defaultProps = {
  forPreview: false,
  enableCustomCollections: true,
};

FacetList.propTypes = {
  collectionList: PropTypes.arrayOf(PropTypes.shape({})),
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFacetValues: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  onSelectCollection: PropTypes.func.isRequired,
  selectedCollectionObjectId: PropTypes.string,
  sort: PropTypes.string,
  onUpdateSort: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  enableCustomCollections: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  facets: state.registryCollections.facets,
  selectedFacetValues: state.registryCollections.selectedFacetValues,
  collectionList: state.registryCollections.collectionList,
  selectedCollectionObjectId: state.registryCollections.selectedCollectionObjectId,
  sort: state.registryCollections.sort,
});

const mapDispatchToProps = dispatch => ({
  onSelectCollection: (collectionObjectId, enableCustomCollections) => {
    dispatch(selectCollection(collectionObjectId));
    dispatch(resetFacetValues());
    dispatch(search(enableCustomCollections));
  },
  onToggleFacet: (facetKey, facetValue, reset = false, enableCustomCollections = true) => {
    if (reset) { dispatch(resetFacetValues(facetKey)); }
    dispatch(toggleFacetValue(facetKey, facetValue, enableCustomCollections));
  },
  onResetFacets: (facetKey, enableCustomCollections) => {
    dispatch(resetFacetValues(facetKey));
    if (!facetKey) {
      dispatch(selectCollection());
      dispatch(updateSort(''));
    }
    dispatch(search(enableCustomCollections));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacetList);



/** WEBPACK FOOTER **
 ** ./src/components/registry/RegistryFacets.jsx
 **/